import { library } from "@fortawesome/fontawesome-svg-core"
import {
	faSpinner,
	faSync,
	faUser,
	faPlus,
	faUserCircle,
	faAngleRight,
	faAngleDoubleRight,
	faAngleLeft,
	faAngleDoubleLeft,
	faTimes,
	faExclamation,
	faBars,
	faUpload,
	faTrash,
	faCalendar,
	faCaretLeft,
	faFilter,
	faSort,
	faCaretDown,
	faCaretUp,
	faAngleUp,
	faAngleDown,
	faHeart,
	faSyncAlt,
	faSearch,
	faImage,
	faEllipsisH,
	faCheck,
	faCheckCircle,
	faInfoCircle,
	faFlag,
	faPhone,
	faMinus,
	faExclamationCircle,
	faLongArrowAltLeft,
	faArrowRight,
	faArrowLeft,
	faStar,
	faChevronDown,
	faLongArrowAltUp,
	faThLarge,
	faThList,
	faClipboard,
	faCode,
	faBell,
	faEnvelope,
	faExternalLinkAlt,
	faEye,
	faEdit,
	faQuestion
} from "@fortawesome/free-solid-svg-icons"
import {
	faHeart as farHeart,
	faEnvelope as farEnvelope,
	faSquare as farSquare,
	faCheckSquare as farCheckSquare,
	faStar as farStar,
	faBell as farBell
} from "@fortawesome/free-regular-svg-icons"
import { fab } from "@fortawesome/free-brands-svg-icons"

library.add(
	faSpinner,
	faSync,
	faUser,
	faPlus,
	faUserCircle,
	farSquare,
	farCheckSquare,
	faCheckCircle,
	faAngleRight,
	faAngleDoubleRight,
	faAngleLeft,
	faAngleDoubleLeft,
	faTimes,
	faExclamation,
	faBars,
	faTrash,
	faUpload,
	faCalendar,
	fab,
	faCaretLeft,
	faFilter,
	faSort,
	faCaretDown,
	faCaretUp,
	faAngleUp,
	faAngleDown,
	faHeart,
	farHeart,
	farEnvelope,
	faSyncAlt,
	faSearch,
	faImage,
	faEllipsisH,
	faCheck,
	faInfoCircle,
	faFlag,
	faPhone,
	faMinus,
	faExclamationCircle,
	faLongArrowAltLeft,
	faArrowRight,
	farStar,
	faStar,
	faChevronDown,
	faLongArrowAltUp,
	faThLarge,
	faThList,
	faClipboard,
	faArrowLeft,
	faCode,
	faBell,
	farBell,
	faEnvelope,
	faExternalLinkAlt,
	faEye,
	faEdit,
	faQuestion
)
